// src/icons.ts
var ICONS = {
  home: `<path d="M3 9.5 12 3l9 6.5V20a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1V9.5Z"/>`,
  compass: `<circle cx="12" cy="12" r="9"/><path d="m15.5 8.5-3 6-6 3 3-6 6-3Z"/>`,
  shield: `<path d="M12 2 4 5v7c0 5 3.5 8.5 8 10 4.5-1.5 8-5 8-10V5l-8-3Z"/>`,
  palette: `<path d="M12 3a9 9 0 0 0 0 18c1.5 0 2-1 2-2v-1c0-1 .5-2 2-2h2a4 4 0 0 0 4-4 9 9 0 0 0-10-9Z"/><circle cx="7.5" cy="10.5" r="1.2"/><circle cx="11.5" cy="7.5" r="1.2"/><circle cx="15.5" cy="9" r="1.2"/>`,
  type: `<path d="M4 7V5h16v2"/><path d="M9 20h6"/><path d="M12 5v15"/>`,
  ruler: `<path d="M3 14 14 3l7 7L10 21l-7-7Z"/><path d="M7 10l2 2"/><path d="M11 6l2 2"/><path d="M15 14l2 2"/>`,
  shapes: `<rect x="3" y="13" width="8" height="8" rx="1"/><circle cx="17" cy="17" r="4"/><path d="M12 3l5 8H7l5-8Z"/>`,
  activity: `<path d="M22 12h-4l-3 9L9 3l-3 9H2"/>`,
  braces: `<path d="M8 3a3 3 0 0 0-3 3v3a2 2 0 0 1-2 2 2 2 0 0 1 2 2v3a3 3 0 0 0 3 3"/><path d="M16 3a3 3 0 0 1 3 3v3a2 2 0 0 0 2 2 2 2 0 0 0-2 2v3a3 3 0 0 1-3 3"/>`,
  blocks: `<rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 17a4 4 0 0 0 4-4V8a5 5 0 0 1 5 5"/><path d="M3 7a4 4 0 0 1 4-4h3"/>`,
  table: `<rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M3 15h18M9 3v18M15 3v18"/>`,
  "git-branch": `<circle cx="6" cy="6" r="2"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="8" r="2"/><path d="M6 8v8"/><path d="M18 10c0 4-6 2-6 8"/>`,
  lock: `<rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>`,
  "layout-dashboard": `<rect x="3" y="3" width="7" height="9" rx="1"/><rect x="14" y="3" width="7" height="5" rx="1"/><rect x="14" y="12" width="7" height="9" rx="1"/><rect x="3" y="16" width="7" height="5" rx="1"/>`,
  "file-text": `<path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z"/><path d="M14 3v5h5"/><path d="M9 13h6M9 17h6"/>`,
  files: `<path d="M9 3h7l4 4v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/><path d="M16 3v4h4"/><path d="M4 7v12a2 2 0 0 0 2 2h9"/>`,
  "plus-circle": `<circle cx="12" cy="12" r="9"/><path d="M12 8v8M8 12h8"/>`,
  users: `<circle cx="9" cy="8" r="3.5"/><path d="M3 20a6 6 0 0 1 12 0"/><path d="M16 5a3.5 3.5 0 0 1 0 7"/><path d="M18 20a6 6 0 0 0-3-5.2"/>`,
  truck: `<path d="M3 17V6a1 1 0 0 1 1-1h11v12"/><path d="M15 8h4l3 4v5h-7"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/>`,
  package: `<path d="m3 8 9-5 9 5v8l-9 5-9-5V8Z"/><path d="m3 8 9 5 9-5"/><path d="M12 13v8"/>`,
  smartphone: `<rect x="6" y="2" width="12" height="20" rx="2"/><path d="M11 18h2"/>`,
  search: `<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>`,
  bell: `<path d="M6 8a6 6 0 0 1 12 0c0 7 3 7 3 9H3c0-2 3-2 3-9Z"/><path d="M10 21a2 2 0 0 0 4 0"/>`,
  settings: `<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1A2 2 0 1 1 4.4 17l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.8l-.1-.1A2 2 0 1 1 7 4.4l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1A2 2 0 1 1 19.6 7l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1Z"/>`,
  help: `<circle cx="12" cy="12" r="9"/><path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3"/><circle cx="12" cy="17" r="0.5"/>`,
  "log-out": `<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="m16 17 5-5-5-5"/><path d="M21 12H9"/>`,
  user: `<circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/>`,
  keyboard: `<rect x="2" y="6" width="20" height="12" rx="2"/><path d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M7 14h10"/>`,
  "chevron-up": `<path d="m6 15 6-6 6 6"/>`,
  "chevron-down": `<path d="m6 9 6 6 6-6"/>`,
  "chevron-left": `<path d="m15 6-6 6 6 6"/>`,
  "chevron-right": `<path d="m9 6 6 6-6 6"/>`,
  check: `<path d="M20 6 9 17l-5-5"/>`,
  "arrow-right": `<path d="M5 12h14M13 6l6 6-6 6"/>`,
  "alert-triangle": `<path d="M10.3 4 2.4 18a2 2 0 0 0 1.7 3h15.8a2 2 0 0 0 1.7-3L13.7 4a2 2 0 0 0-3.4 0Z"/><path d="M12 9v4M12 17h.01"/>`,
  "alert-circle": `<circle cx="12" cy="12" r="9"/><path d="M12 8v4M12 16h.01"/>`,
  info: `<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/>`,
  calendar: `<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 9h18M8 3v4M16 3v4"/>`,
  clock: `<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>`,
  "map-pin": `<path d="M12 21s7-6 7-11a7 7 0 1 0-14 0c0 5 7 11 7 11Z"/><circle cx="12" cy="10" r="2.5"/>`,
  download: `<path d="M12 3v12M7 11l5 5 5-5"/><path d="M5 21h14"/>`,
  paperclip: `<path d="M21 11.5 12 20.5a5 5 0 0 1-7-7l9-9a3.5 3.5 0 0 1 5 5l-9 9a2 2 0 0 1-3-3l8-8"/>`,
  euro: `<path d="M17 6a6 6 0 1 0 0 12"/><path d="M5 10h8M5 14h8"/>`,
  // Row actions in a dense grid. Text buttons ("Bewerken" / "Verwijderen") cost
  // ~190px of a tariff table that has nine columns, which is width the
  // werkzaamheden column needs far more.
  pencil: `<path d="m15 4 5 5"/><path d="M17.5 2.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 13.5-13.5Z"/>`,
  // Drag handle for a reorderable row. Lucide's grip-vertical: two columns of
  // three dots, the one shape everyone already reads as "pick me up".
  grip: `<circle cx="9" cy="6" r="1.1"/><circle cx="9" cy="12" r="1.1"/><circle cx="9" cy="18" r="1.1"/><circle cx="15" cy="6" r="1.1"/><circle cx="15" cy="12" r="1.1"/><circle cx="15" cy="18" r="1.1"/>`,
  trash: `<path d="M4 6h16"/><path d="M9 6V4h6v2"/><path d="M6 6v13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6"/><path d="M10 11v6M14 11v6"/>`,
  // List tables: the filter on a column header, the column menu, and going back
  // to the default layout. Lucide's funnel, columns-3 and rotate-ccw.
  filter: `<path d="M3 4h18l-7 8.5V19l-4 2v-8.5L3 4Z"/>`,
  columns: `<rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 3v18M15 3v18"/>`,
  "rotate-ccw": `<path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/>`,
  x: `<path d="M18 6 6 18M6 6l12 12"/>`
};
function iconSvg(name, { size = 16, stroke = 1.6 } = {}) {
  const body = ICONS[name] ?? "";
  return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="${stroke}" stroke-linecap="round" stroke-linejoin="round">${body}</svg>`;
}

// src/Icon.tsx
import { jsx } from "react/jsx-runtime";
function Icon({ name, size = 16, stroke = 1.6, ...rest }) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": rest["aria-label"] ? void 0 : true,
      ...rest,
      dangerouslySetInnerHTML: { __html: ICONS[name] ?? "" }
    }
  );
}
export {
  ICONS,
  Icon,
  iconSvg
};
